module.exports = __webpack_public_path__ + "static/media/fiberpay_background.8ac301a8.jpg";